import ContractStatusDot from "../../core/components/StatusDot/ContractStatusDot";
import { constantToDisplayName } from "../../core/constantToDisplayName";
import { useFormatUserDate } from "../../core/useFormatUserDate";
import { UserRole } from 'legoland-sdk/dist/experimental';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { tombac, TooltipOnHover } from 'tombac';
import { ContractAccessTypeIcon } from "../common/ContractAccessTypeIcon";
import { ContractExpires } from "../common/ContractExpires";
import { ContractProductsList } from "../common/ContractProductsList";
import { ContractStatus } from "../contractTypes";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const ContractLink = styled(Link).withConfig({
  displayName: "createContractListColumns__ContractLink"
})(["", ""], tombac.text({
  fontWeight: 500
}));
export function createContractListColumns(_ref) {
  let {
    variant,
    userRole
  } = _ref;
  return [{
    Header: /*#__PURE__*/_jsx(_Fragment, {
      children: "\xA0"
    }),
    width: 52,
    accessor: 'status',
    Cell: _ref2 => {
      let {
        value
      } = _ref2;
      return /*#__PURE__*/_jsx(ContractStatusDot, {
        $display: "inline-block",
        status: value
      });
    },
    disableSortBy: true
  }, {
    Header: 'Contract ID',
    width: 150,
    accessor: 'contractId',
    Cell: _ref3 => {
      let {
        row,
        value
      } = _ref3;
      return value ? /*#__PURE__*/_jsx(ContractLink, {
        to: `/contracts/${row.original.id}`,
        children: value
      }) : null;
    }
  }, {
    Header: 'Name / Legal number',
    width: 'auto',
    accessor: 'name',
    Cell: _ref4 => {
      let {
        row,
        value
      } = _ref4;
      return /*#__PURE__*/_jsx(ContractLink, {
        to: `/contracts/${row.original.id}`,
        children: value || 'Unnamed contract'
      });
    }
  }, ...(variant !== 'narrow' ? [{
    Header: 'Organization',
    id: 'organization.name',
    width: 'auto',
    accessor: row => row.organization.name,
    disableSortBy: true
  }, ...(userRole !== UserRole.Distributor ? [{
    Header: 'SAP ID',
    id: 'organization.sapId',
    width: 95,
    accessor: row => row.organization.sapId,
    disableSortBy: true
  }] : [])] : []), {
    Header: 'Start date',
    width: 105,
    accessor: 'startDate',
    Cell: _ref5 => {
      let {
        value
      } = _ref5;
      const formatDate = useFormatUserDate();
      return /*#__PURE__*/_jsx(_Fragment, {
        children: formatDate(value)
      });
    }
  }, {
    Header: 'End date',
    width: 105,
    accessor: 'endDate',
    Cell: _ref6 => {
      let {
        value
      } = _ref6;
      const formatDate = useFormatUserDate();
      return /*#__PURE__*/_jsx(_Fragment, {
        children: formatDate(value)
      });
    }
  }, {
    Header: 'Remaining',
    width: 85,
    accessor: 'remainingDays',
    Cell: _ref7 => {
      let {
        row
      } = _ref7;
      return row.original.status !== ContractStatus.Upcoming ? /*#__PURE__*/_jsx(ContractExpires, {
        contract: row.original,
        variant: "condenced"
      }) : null;
    }
  }, ...(variant !== 'narrow' ? [{
    Header: 'Users',
    id: 'users',
    accessor: row => row.users.length,
    width: 60
  }] : []), {
    Header: 'Access',
    accessor: 'accessType',
    Cell: _ref8 => {
      let {
        value
      } = _ref8;
      return /*#__PURE__*/_jsx(TooltipOnHover, {
        content: constantToDisplayName(value ? value : ''),
        placement: "top",
        size: "s",
        children: value && /*#__PURE__*/_jsx(ContractAccessTypeIcon, {
          accessType: value
        })
      });
    },
    width: 68,
    disableSortBy: true
  }, {
    Header: 'Products',
    accessor: 'products',
    Cell: _ref9 => {
      let {
        row,
        value
      } = _ref9;
      return /*#__PURE__*/_jsx(ContractProductsList, {
        $p: "0",
        expired: row.original.status === ContractStatus.Expired,
        products: value
      });
    },
    width: 6 * 32 + 4 * 8 + 12 + 24,
    // 5 * (icon width) + 4 * (space between) + (left + right padding)
    disableSortBy: true
  }];
}